export default {
  apiBackend: process.env.REACT_APP_BACKEND_URI,
  graphSchemeUrl: process.env.REACT_APP_GRAPH_URI,
};
